import { useQuery } from "@tanstack/react-query";
import { dropdownService } from "../api/services/dropdownService";

export const useAdGroupOptions = () => {
  const {
    data: adGroupOptions,
    isLoading: isAdGroupOptionsLoading,
    refetch: refetchAdGroupOptions,
  } = useQuery({
    queryKey: ["adGroupOptions"],
    queryFn: () => dropdownService.getAdGroupOptions(),
  });

  return {
    adGroupOptions: adGroupOptions || [],
    isAdGroupOptionsLoading,
    refetchAdGroupOptions,
  };
};
